import React from 'react';
import useEditorContext from '../hooks/useEditorContext';
import DraftModeActions from './editorActions/DraftModeActions';
import PublishedModeActions from './editorActions/PublishedModeActions';
import ViewerModeActions from './editorActions/ViewerModeActions';

const EditContentsPrimaryArea = () => {
  const { canModify, isPublishedMode } = useEditorContext();

  if (!canModify) return <ViewerModeActions />;

  return isPublishedMode ? <PublishedModeActions /> : <DraftModeActions />;
};

export default EditContentsPrimaryArea;
